// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2oS1z","selects":"Documents_selects__1fs8D"};